"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _isNumber2 = _interopRequireDefault(require("lodash/isNumber"));
var _DataTable = _interopRequireDefault(require("../../class/DataTable"));
var _common = require("../../util/common");
// import _chain from 'lodash/chain';

module.exports = {
  getBlocks: function getBlocks() {
    var getSubMenus = function getSubMenus(value) {
      var _ref = _DataTable["default"].getSource(value) || {},
        _ref$fields = _ref.fields,
        fields = _ref$fields === void 0 ? [] : _ref$fields;
      return fields.map(function (label, index) {
        return [label, index + 1];
      });
    };
    var getColumnNumber = function getColumnNumber(str) {
      if (/\d/.test(str)) {
        return -1;
      }
      return (
        // _chain(str)
        // did not work..
        _.chain(str).toUpper().reduce(function (prev, curr) {
          return prev * 26 + curr.charCodeAt() - 64;
        }, 0).value()
      );
    };
    return {
      analizyDataAddButton: {
        skeleton: 'basic_button',
        color: EntryStatic.colorSet.common.BUTTON_BACKGROUND,
        params: [{
          type: 'Text',
          text: Lang.Workspace.open_analizy_data_import,
          color: EntryStatic.colorSet.common.BUTTON,
          align: 'center'
        }],
        def: {
          type: 'analizyDataAddButton'
        },
        events: {
          mousedown: [function () {
            Entry.playground.dataTable.show();
          }]
        },
        syntax: {
          js: [],
          py: ['']
        }
      },
      append_row_to_table: {
        color: EntryStatic.colorSet.block["default"].ANALYSIS,
        outerLine: EntryStatic.colorSet.block.darken.ANALYSIS,
        skeleton: 'basic',
        statements: [],
        params: [{
          type: 'DropdownDynamic',
          value: null,
          menuName: 'tables',
          dropdownSync: 'dataTables',
          fontSize: 10,
          bgColor: EntryStatic.colorSet.block.darken.ANALYSIS,
          arrowColor: EntryStatic.colorSet.arrow["default"].DEFAULT
        }, {
          type: 'Dropdown',
          options: [[Lang.Blocks.table_row, 'ROW'], [Lang.Blocks.table_col, 'COL']],
          value: 'ROW',
          fontSize: 10,
          bgColor: EntryStatic.colorSet.block.darken.ANALYSIS,
          arrowColor: EntryStatic.colorSet.arrow["default"].DEFAULT
        }, {
          type: 'Indicator',
          img: 'block_icon/block_analysis.svg',
          size: 11
        }],
        events: {},
        def: {
          params: [null, null, null],
          type: 'append_row_to_table'
        },
        pyHelpDef: {
          params: [{
            type: 'text',
            params: ['A&value']
          }, {
            type: 'text',
            params: ['B&value']
          }],
          type: 'append_row_to_table'
        },
        paramsKeyMap: {
          MATRIX: 0,
          PROPERTY: 1
        },
        "class": 'analysis',
        isNotFor: ['analysis'],
        func: function func(sprite, script) {
          return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
            var tableId, property, table;
            return _regenerator["default"].wrap(function (_context) {
              while (1) switch (_context.prev = _context.next) {
                case 0:
                  tableId = script.getField('MATRIX', script);
                  property = script.getStringValue('PROPERTY', script);
                  table = _DataTable["default"].getSource(tableId, sprite);
                  if (!(property === 'ROW')) {
                    _context.next = 2;
                    break;
                  }
                  _context.next = 1;
                  return table.appendRow();
                case 1:
                  _context.next = 3;
                  break;
                case 2:
                  _context.next = 3;
                  return table.appendCol();
                case 3:
                  return _context.abrupt("return", script.callReturn());
                case 4:
                case "end":
                  return _context.stop();
              }
            }, _callee);
          }))();
        },
        syntax: {
          js: [],
          py: []
        }
      },
      insert_row_to_table: {
        color: EntryStatic.colorSet.block["default"].ANALYSIS,
        outerLine: EntryStatic.colorSet.block.darken.ANALYSIS,
        skeleton: 'basic',
        statements: [],
        params: [{
          type: 'DropdownDynamic',
          value: null,
          menuName: 'tables',
          dropdownSync: 'dataTables',
          fontSize: 10,
          bgColor: EntryStatic.colorSet.block.darken.ANALYSIS,
          arrowColor: EntryStatic.colorSet.arrow["default"].DEFAULT
        }, {
          type: 'Block',
          accept: 'string',
          defaultType: 'number'
        }, {
          type: 'Dropdown',
          options: [[Lang.Blocks.table_row, 'ROW'], [Lang.Blocks.table_col, 'COL']],
          value: 'ROW',
          fontSize: 10,
          bgColor: EntryStatic.colorSet.block.darken.ANALYSIS,
          arrowColor: EntryStatic.colorSet.arrow["default"].DEFAULT
        }, {
          type: 'Indicator',
          img: 'block_icon/block_analysis.svg',
          size: 11
        }],
        events: {},
        def: {
          params: [null, {
            type: 'text',
            params: ['2']
          }, null, null],
          type: 'insert_row_to_table'
        },
        pyHelpDef: {
          params: [{
            type: 'text',
            params: ['B&value']
          }, {
            type: 'text',
            params: ['A&value']
          }, {
            type: 'text',
            params: ['C&value']
          }, null],
          type: 'insert_row_to_table'
        },
        paramsKeyMap: {
          MATRIX: 0,
          NUMBER: 1,
          PROPERTY: 2
        },
        "class": 'analysis',
        isNotFor: ['analysis'],
        func: function func(sprite, script) {
          return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2() {
            var tableId, number, property, table;
            return _regenerator["default"].wrap(function (_context2) {
              while (1) switch (_context2.prev = _context2.next) {
                case 0:
                  tableId = script.getField('MATRIX', script);
                  number = script.getNumberValue('NUMBER', script);
                  property = script.getStringValue('PROPERTY', script);
                  table = _DataTable["default"].getSource(tableId, sprite);
                  if (!(property === 'ROW')) {
                    _context2.next = 2;
                    break;
                  }
                  _context2.next = 1;
                  return table.insertRow(number - 1);
                case 1:
                  _context2.next = 3;
                  break;
                case 2:
                  _context2.next = 3;
                  return table.insertCol(number);
                case 3:
                  return _context2.abrupt("return", script.callReturn());
                case 4:
                case "end":
                  return _context2.stop();
              }
            }, _callee2);
          }))();
        },
        syntax: {
          js: [],
          py: []
        }
      },
      delete_row_from_table: {
        color: EntryStatic.colorSet.block["default"].ANALYSIS,
        outerLine: EntryStatic.colorSet.block.darken.ANALYSIS,
        skeleton: 'basic',
        statements: [],
        params: [{
          type: 'DropdownDynamic',
          value: null,
          menuName: 'tables',
          dropdownSync: 'dataTables',
          fontSize: 10,
          bgColor: EntryStatic.colorSet.block.darken.ANALYSIS,
          arrowColor: EntryStatic.colorSet.arrow["default"].DEFAULT
        }, {
          type: 'Block',
          accept: 'string',
          defaultType: 'number'
        }, {
          type: 'Dropdown',
          options: [[Lang.Blocks.table_row, 'ROW'], [Lang.Blocks.table_col, 'COL']],
          value: 'ROW',
          fontSize: 10,
          bgColor: EntryStatic.colorSet.block.darken.ANALYSIS,
          arrowColor: EntryStatic.colorSet.arrow["default"].DEFAULT
        }, {
          type: 'Indicator',
          img: 'block_icon/block_analysis.svg',
          size: 11
        }],
        events: {},
        def: {
          params: [null, {
            type: 'text',
            params: ['2']
          }, null, null],
          type: 'delete_row_from_table'
        },
        pyHelpDef: {
          params: [{
            type: 'text',
            params: ['B&value']
          }, {
            type: 'text',
            params: ['A&value']
          }, {
            type: 'text',
            params: ['C&value']
          }, null],
          type: 'delete_row_from_table'
        },
        paramsKeyMap: {
          MATRIX: 0,
          NUMBER: 1,
          PROPERTY: 2
        },
        "class": 'analysis',
        isNotFor: ['analysis'],
        func: function func(sprite, script) {
          var tableId = script.getField('MATRIX', script);
          var number = script.getNumberValue('NUMBER', script);
          var property = script.getStringValue('PROPERTY', script);
          var table = _DataTable["default"].getSource(tableId, sprite);
          if (property === 'ROW') {
            table.deleteRow(number - 1);
          } else {
            table.deleteCol(number);
          }
          return script.callReturn();
        },
        syntax: {
          js: [],
          py: []
        }
      },
      set_value_from_table: {
        color: EntryStatic.colorSet.block["default"].ANALYSIS,
        outerLine: EntryStatic.colorSet.block.darken.ANALYSIS,
        skeleton: 'basic',
        statements: [],
        params: [{
          type: 'DropdownDynamic',
          value: null,
          menuName: 'tables',
          dropdownSync: 'dataTables',
          fontSize: 10,
          bgColor: EntryStatic.colorSet.block.darken.ANALYSIS,
          arrowColor: EntryStatic.colorSet.arrow["default"].DEFAULT
        }, {
          type: 'Block',
          accept: 'string',
          defaultType: 'number'
        }, {
          type: 'Block',
          accept: 'string',
          defaultType: 'number'
        }, {
          type: 'Block',
          accept: 'string',
          defaultType: 'number'
        }, {
          type: 'Indicator',
          img: 'block_icon/block_analysis.svg',
          size: 11
        }],
        events: {},
        def: {
          params: [null, {
            type: 'text',
            params: ['2']
          }, {
            type: 'get_table_fields'
          }, {
            type: 'text',
            params: ['10']
          }, null],
          type: 'set_value_from_table'
        },
        pyHelpDef: {
          params: [{
            type: 'text',
            params: ['D&value']
          }, {
            type: 'text',
            params: ['C&value']
          }, {
            type: 'text',
            params: ['B&value']
          }, {
            type: 'text',
            params: ['A&value']
          }, null],
          type: 'set_value_from_table'
        },
        paramsKeyMap: {
          MATRIX: 0,
          NUMBER: 1,
          FIELD: 2,
          VALUE: 3
        },
        "class": 'analysis',
        isNotFor: ['analysis'],
        func: function func(sprite, script) {
          var tableId = script.getField('MATRIX', script);
          var row = script.getNumberValue('NUMBER', script) - 1;
          var col = _DataTable["default"].getColumnIndex(script.getValue('FIELD', script));
          var value = script.getValue('VALUE', script);
          var table = _DataTable["default"].getSource(tableId, sprite);
          if (table.isExist([row, col])) {
            table.replaceValue([row, col], value);
          }
          return script.callReturn();
        },
        syntax: {
          js: [],
          py: []
        }
      },
      // 테이블 $1의 현재 상태를 저장하기
      save_current_table: {
        color: EntryStatic.colorSet.block["default"].ANALYSIS,
        outerLine: EntryStatic.colorSet.block.darken.ANALYSIS,
        skeleton: 'basic',
        statements: [],
        params: [{
          type: 'DropdownDynamic',
          value: null,
          menuName: 'tables',
          dropdownSync: 'dataTables',
          fontSize: 10,
          bgColor: EntryStatic.colorSet.block.darken.ANALYSIS,
          arrowColor: EntryStatic.colorSet.arrow["default"].DEFAULT
        }, {
          type: 'Indicator',
          img: 'block_icon/block_analysis.svg',
          size: 11
        }],
        events: {},
        def: {
          params: [null, null],
          type: 'save_current_table'
        },
        pyHelpDef: {
          params: [{
            type: 'text',
            params: ['D&value']
          }, null],
          type: 'save_current_table'
        },
        paramsKeyMap: {
          MATRIX: 0
        },
        "class": 'analysis',
        isNotFor: ['analysis'],
        func: function func(sprite, script) {
          var tableId = script.getField('MATRIX', script);
          var table = _DataTable["default"].getSource(tableId);
          _DataTable["default"].saveTable({
            selected: table.dataTable
          });
          return script.callReturn();
        },
        syntax: {
          js: [],
          py: []
        }
      },
      // 테이블 %1 %2 개수
      get_table_count: {
        color: EntryStatic.colorSet.block["default"].ANALYSIS,
        outerLine: EntryStatic.colorSet.block.darken.ANALYSIS,
        skeleton: 'basic_string_field',
        statements: [],
        params: [{
          type: 'DropdownDynamic',
          value: null,
          menuName: 'tables',
          dropdownSync: 'dataTables',
          fontSize: 10,
          bgColor: EntryStatic.colorSet.block.darken.ANALYSIS,
          arrowColor: EntryStatic.colorSet.arrow["default"].DEFAULT
        }, {
          type: 'Dropdown',
          options: [[Lang.Blocks.table_row, 'ROW'], [Lang.Blocks.table_col, 'COL']],
          value: 'ROW',
          fontSize: 10,
          bgColor: EntryStatic.colorSet.block.darken.ANALYSIS,
          arrowColor: EntryStatic.colorSet.arrow["default"].DEFAULT
        }],
        events: {},
        pyHelpDef: {
          params: [{
            type: 'text',
            params: ['D&value']
          }, null],
          type: 'get_table_count'
        },
        def: {
          params: [null, null],
          type: 'get_table_count'
        },
        paramsKeyMap: {
          MATRIX: 0,
          PROPERTY: 1
        },
        "class": 'analysis',
        isNotFor: ['analysis'],
        func: function func(sprite, script) {
          var tableId = script.getField('MATRIX', script);
          var property = script.getStringValue('PROPERTY', script);
          var table = _DataTable["default"].getSource(tableId, sprite);
          if (property === 'ROW') {
            var array = table.array;
            return array.length + 1;
          } else if (property === 'COL') {
            var labels = table.fields;
            return labels.length;
          }
          return 0;
        },
        syntax: {
          js: [],
          py: []
        }
      },
      // 테이블 %1 행 %2 속성 %3 의 값
      get_value_from_table: {
        color: EntryStatic.colorSet.block["default"].ANALYSIS,
        outerLine: EntryStatic.colorSet.block.darken.ANALYSIS,
        skeleton: 'basic_string_field',
        statements: [],
        params: [{
          type: 'DropdownDynamic',
          value: null,
          menuName: 'tables',
          dropdownSync: 'dataTables',
          fontSize: 10,
          bgColor: EntryStatic.colorSet.block.darken.ANALYSIS,
          arrowColor: EntryStatic.colorSet.arrow["default"].DEFAULT
        }, {
          type: 'Block',
          accept: 'string',
          defaultType: 'number'
        }, {
          type: 'Block',
          accept: 'string',
          defaultType: 'number'
        }],
        events: {},
        def: {
          params: [null, {
            type: 'text',
            params: ['2']
          }, {
            type: 'get_table_fields'
          }],
          type: 'get_value_from_table'
        },
        paramsKeyMap: {
          MATRIX: 0,
          ROW: 1,
          COL: 2
        },
        "class": 'analysis',
        isNotFor: ['analysis'],
        func: function func(sprite, script) {
          var tableId = script.getField('MATRIX', script);
          var row = script.getNumberValue('ROW', script) - 1;
          var col = _DataTable["default"].getColumnIndex(script.getValue('COL', script));
          var table = _DataTable["default"].getSource(tableId, sprite);
          if (table.isExist([row, col])) {
            return table.getValue([row, col]);
          }
          return null;
        },
        syntax: {
          js: [],
          py: []
        }
      },
      get_value_from_last_row: {
        color: EntryStatic.colorSet.block["default"].ANALYSIS,
        outerLine: EntryStatic.colorSet.block.darken.ANALYSIS,
        skeleton: 'basic_string_field',
        statements: [],
        params: [{
          type: 'DropdownDynamic',
          value: null,
          menuName: 'tables',
          dropdownSync: 'dataTables',
          fontSize: 10,
          bgColor: EntryStatic.colorSet.block.darken.ANALYSIS,
          arrowColor: EntryStatic.colorSet.arrow["default"].DEFAULT
        }, {
          type: 'Block',
          accept: 'string',
          defaultType: 'number'
        }],
        events: {},
        def: {
          params: [null, {
            type: 'get_table_fields'
          }],
          type: 'get_value_from_last_row'
        },
        paramsKeyMap: {
          MATRIX: 0,
          COL: 1
        },
        "class": 'analysis',
        isNotFor: ['analysis'],
        func: function func(sprite, script) {
          var tableId = script.getField('MATRIX', script);
          var col = _DataTable["default"].getColumnIndex(script.getValue('COL', script));
          var table = _DataTable["default"].getSource(tableId, sprite);
          var row = table && table.array.length;
          if (table.isExist([row, col])) {
            return table.getValue([row, col]);
          }
          return null;
        },
        syntax: {
          js: [],
          py: []
        }
      },
      // 테이블 %1 속성 %1의 합
      calc_values_from_table: {
        color: EntryStatic.colorSet.block["default"].ANALYSIS,
        outerLine: EntryStatic.colorSet.block.darken.ANALYSIS,
        skeleton: 'basic_string_field',
        statements: [],
        params: [{
          type: 'DropdownDynamic',
          value: null,
          menuName: 'tables',
          dropdownSync: 'dataTables',
          fontSize: 10,
          bgColor: EntryStatic.colorSet.block.darken.ANALYSIS,
          arrowColor: EntryStatic.colorSet.arrow["default"].DEFAULT
        }, {
          type: 'Block',
          accept: 'string',
          defaultType: 'number'
        }, {
          type: 'Dropdown',
          options: [[Lang.Blocks.table_sum, 'SUM'], [Lang.Blocks.table_max, 'MAX'], [Lang.Blocks.table_min, 'MIN'], [Lang.Blocks.table_avg, 'AVG'], [Lang.Blocks.table_stdev, 'STDEV'], [Lang.Blocks.table_median, 'MEDIAN']],
          value: 'SUM',
          fontSize: 10,
          bgColor: EntryStatic.colorSet.block.darken.ANALYSIS,
          arrowColor: EntryStatic.colorSet.arrow["default"].DEFAULT
        }],
        events: {},
        def: {
          params: [null, {
            type: 'get_table_fields'
          }, null],
          type: 'calc_values_from_table'
        },
        paramsKeyMap: {
          MATRIX: 0,
          COL: 1,
          CALC: 2
        },
        "class": 'analysis',
        isNotFor: ['analysis'],
        func: function func(sprite, script) {
          var tableId = script.getField('MATRIX', script);
          var calc = script.getField('CALC', script);
          var col = _DataTable["default"].getColumnIndex(script.getValue('COL', script));
          var table = _DataTable["default"].getSource(tableId, sprite);
          var array = table.array.map(function (_ref2) {
            var _ref2$value = _ref2.value,
              value = _ref2$value === void 0 ? [] : _ref2$value;
            var parsed = (0, _common.toNumber)(value[col - 1]);
            return (0, _isNumber2["default"])(parsed) ? parsed : 0;
          });
          var total = array.length;
          var sum = function sum(x, y) {
            return x + y;
          };
          var square = function square(x) {
            return x * x;
          };
          if (!total) {
            return 0;
          }
          switch (calc) {
            case 'SUM':
              return array.reduce(sum);
            case 'MAX':
              return array.reduce(function (x, y) {
                return Math.max(x, y);
              });
            case 'MIN':
              return array.reduce(function (x, y) {
                return Math.min(x, y);
              });
            case 'AVG':
              return array.reduce(sum) / total;
            case 'STDEV':
              {
                var avg = array.reduce(sum) / total;
                var deviations = array.map(function (x) {
                  return x - avg;
                });
                return Math.sqrt(deviations.map(square).reduce(sum) / (total - 1));
              }
            case 'MEDIAN':
              {
                var sorted = array.sort(function (a, b) {
                  return a - b;
                });
                var n = Math.floor(array.length / 2);
                return (sorted[n] + sorted[array.length - 1 - n]) / 2;
              }
            default:
              return 0;
          }
        },
        syntax: {
          js: [],
          py: []
        }
      },
      // 테이블 %1 창 열기
      open_table: {
        color: EntryStatic.colorSet.block["default"].ANALYSIS,
        outerLine: EntryStatic.colorSet.block.darken.ANALYSIS,
        skeleton: 'basic',
        statements: [],
        params: [{
          type: 'DropdownDynamic',
          value: null,
          menuName: 'tables',
          dropdownSync: 'dataTables',
          fontSize: 10,
          bgColor: EntryStatic.colorSet.block.darken.ANALYSIS,
          arrowColor: EntryStatic.colorSet.arrow["default"].DEFAULT
        }, {
          type: 'Indicator',
          img: 'block_icon/block_analysis.svg',
          size: 11
        }],
        events: {},
        def: {
          params: [null, null, null],
          type: 'open_table'
        },
        pyHelpDef: {
          params: [{
            type: 'text',
            params: ['A&value', 'B&value']
          }, null],
          type: 'open_table'
        },
        paramsKeyMap: {
          MATRIX: 0,
          CHART_INDEX: 1
        },
        "class": 'analysis',
        isNotFor: ['analysis'],
        func: function func(sprite, script) {
          var tableId = script.getField('MATRIX', script);
          _DataTable["default"].showTable(tableId);
          return script.callReturn();
        },
        syntax: {
          js: [],
          py: []
        }
      },
      // 테이블 %1 창을 %2 초 동안 열기
      open_table_wait: {
        color: EntryStatic.colorSet.block["default"].ANALYSIS,
        outerLine: EntryStatic.colorSet.block.darken.ANALYSIS,
        skeleton: 'basic',
        statements: [],
        params: [{
          type: 'DropdownDynamic',
          value: null,
          menuName: 'tables',
          dropdownSync: 'dataTables',
          fontSize: 10,
          bgColor: EntryStatic.colorSet.block.darken.ANALYSIS,
          arrowColor: EntryStatic.colorSet.arrow["default"].DEFAULT
        }, {
          type: 'Block',
          accept: 'string',
          defaultType: 'number'
        }, {
          type: 'Indicator',
          img: 'block_icon/block_analysis.svg',
          size: 11
        }],
        events: {},
        def: {
          params: [null, {
            type: 'number',
            params: ['4']
          }, null],
          type: 'open_table_wait'
        },
        pyHelpDef: {
          params: [{
            type: 'text',
            params: ['A&value', 'B&value']
          }, {
            type: 'number',
            params: ['B&value']
          }, null],
          type: 'open_table_wait'
        },
        paramsKeyMap: {
          MATRIX: 0,
          SECOND: 1
        },
        "class": 'analysis',
        isNotFor: ['analysis'],
        func: function func(sprite, script) {
          var tableId = script.getField('MATRIX', script);
          var timeValue = script.getNumberValue('SECOND', script);
          _DataTable["default"].showTable(tableId);
          Entry.engine.setTimeout(function () {
            _DataTable["default"].closeModal();
          }, timeValue * 1000);
          return script.callReturn();
        },
        syntax: {
          js: [],
          py: []
        }
      },
      // 테이블 %1 의 %2 차트 창 열기
      open_table_chart: {
        color: EntryStatic.colorSet.block["default"].ANALYSIS,
        outerLine: EntryStatic.colorSet.block.darken.ANALYSIS,
        skeleton: 'basic',
        statements: [],
        params: [{
          type: 'DropdownDynamic',
          value: null,
          menuName: 'tables',
          dropdownSync: 'dataTables',
          fontSize: 10,
          bgColor: EntryStatic.colorSet.block.darken.ANALYSIS,
          arrowColor: EntryStatic.colorSet.arrow["default"].DEFAULT
        }, {
          type: 'DropdownDynamic',
          value: null,
          menuName: function menuName() {
            var value = this.getTargetValue('dataTables');
            var source = _DataTable["default"].getSource(value);
            var _ref3 = source || {},
              _ref3$chart = _ref3.chart,
              charts = _ref3$chart === void 0 ? [] : _ref3$chart;
            return charts.map(function (_ref4, index) {
              var title = _ref4.title;
              return [title, index];
            });
          },
          needDeepCopy: true,
          fontSize: 10,
          bgColor: EntryStatic.colorSet.block.darken.ANALYSIS,
          arrowColor: EntryStatic.colorSet.arrow["default"].DEFAULT,
          defaultValue: function defaultValue(value, options) {
            if (options.length) {
              return options[0][1];
            }
            return null;
          }
        }, {
          type: 'Indicator',
          img: 'block_icon/block_analysis.svg',
          size: 11
        }],
        events: {},
        def: {
          params: [null, null, null],
          type: 'open_table_chart'
        },
        pyHelpDef: {
          params: [{
            type: 'text',
            params: ['A&value', 'B&value']
          }, null],
          type: 'open_table_chart'
        },
        paramsKeyMap: {
          MATRIX: 0,
          CHART_INDEX: 1
        },
        "class": 'analysis',
        isNotFor: ['analysis'],
        func: function func(sprite, script) {
          var tableId = script.getField('MATRIX', script);
          var chartIndex = script.getField('CHART_INDEX', script);
          _DataTable["default"].showChart(tableId, chartIndex);
          return script.callReturn();
        },
        syntax: {
          js: [],
          py: []
        }
      },
      close_table_chart: {
        color: EntryStatic.colorSet.block["default"].ANALYSIS,
        outerLine: EntryStatic.colorSet.block.darken.ANALYSIS,
        skeleton: 'basic',
        statements: [],
        params: [{
          type: 'Indicator',
          img: 'block_icon/block_analysis.svg',
          size: 11
        }],
        events: {},
        def: {
          params: [null, null],
          type: 'close_table_chart'
        },
        pyHelpDef: {
          params: [null],
          type: 'close_table_chart'
        },
        paramsKeyMap: {},
        "class": 'analysis',
        isNotFor: ['analysis'],
        func: function func(sprite, script) {
          _DataTable["default"].closeModal();
          return script.callReturn();
        },
        syntax: {
          js: [],
          py: []
        }
      },
      get_coefficient: {
        color: EntryStatic.colorSet.block["default"].ANALYSIS,
        outerLine: EntryStatic.colorSet.block.darken.ANALYSIS,
        skeleton: 'basic_string_field',
        statements: [],
        params: [{
          type: 'DropdownDynamic',
          value: null,
          menuName: 'tables',
          dropdownSync: 'dataTables',
          fontSize: 10,
          bgColor: EntryStatic.colorSet.block.darken.ANALYSIS,
          arrowColor: EntryStatic.colorSet.arrow["default"].DEFAULT
        }, {
          type: 'Block',
          accept: 'string',
          defaultType: 'number'
        }, {
          type: 'Block',
          accept: 'string',
          defaultType: 'number'
        }],
        events: {},
        def: {
          params: [null, {
            type: 'get_table_fields'
          }, {
            type: 'get_table_fields'
          }],
          type: 'get_coefficient'
        },
        pyHelpDef: {
          params: [{
            type: 'text',
            params: ['A&value']
          }, {
            type: 'text',
            params: ['B&value']
          }, {
            type: 'text',
            params: ['C&value']
          }, null],
          type: 'get_coefficient'
        },
        paramsKeyMap: {
          MATRIX: 0,
          FIELD1: 1,
          FIELD2: 2
        },
        "class": 'analysis',
        isNotFor: ['analysis'],
        func: function func(sprite, script) {
          var tableId = script.getField('MATRIX', script);
          var x = _DataTable["default"].getColumnIndex(script.getValue('FIELD1', script));
          var y = _DataTable["default"].getColumnIndex(script.getValue('FIELD2', script));
          var table = _DataTable["default"].getSource(tableId, sprite);
          return table.getCoefficient(x - 1, y - 1);
        },
        syntax: {
          js: [],
          py: []
        }
      },
      set_value_from_cell: {
        color: EntryStatic.colorSet.block["default"].ANALYSIS,
        outerLine: EntryStatic.colorSet.block.darken.ANALYSIS,
        skeleton: 'basic',
        statements: [],
        params: [{
          type: 'DropdownDynamic',
          value: null,
          menuName: 'tables',
          dropdownSync: 'dataTables',
          fontSize: 10,
          bgColor: EntryStatic.colorSet.block.darken.ANALYSIS,
          arrowColor: EntryStatic.colorSet.arrow["default"].DEFAULT
        }, {
          type: 'Block',
          accept: 'string'
        }, {
          type: 'Block',
          accept: 'string'
        }, {
          type: 'Indicator',
          img: 'block_icon/block_analysis.svg',
          size: 11
        }],
        events: {},
        def: {
          params: [null, {
            type: 'text',
            params: ['A2']
          }, {
            type: 'text',
            params: ['10']
          }, null],
          type: 'set_value_from_cell'
        },
        paramsKeyMap: {
          MATRIX: 0,
          CELL: 1,
          VALUE: 2
        },
        "class": 'analysis',
        isNotFor: ['analysis'],
        func: function func(sprite, script) {
          var tableId = script.getField('MATRIX', script);
          var cell = script.getValue('CELL', script) || '';
          var value = script.getValue('VALUE', script);
          var table = _DataTable["default"].getSource(tableId, sprite);
          var _Entry$Utils$cellToRo = Entry.Utils.cellToRowCol(cell.toUpperCase()),
            col = _Entry$Utils$cellToRo.col,
            row = _Entry$Utils$cellToRo.row;
          if (table.isExist([row, col])) {
            table.replaceValue([row, col], value);
          }
          return script.callReturn();
        },
        syntax: {
          js: [],
          py: []
        }
      },
      get_value_from_cell: {
        color: EntryStatic.colorSet.block["default"].ANALYSIS,
        outerLine: EntryStatic.colorSet.block.darken.ANALYSIS,
        skeleton: 'basic_string_field',
        statements: [],
        params: [{
          type: 'DropdownDynamic',
          value: null,
          menuName: 'tables',
          dropdownSync: 'dataTables',
          fontSize: 10,
          bgColor: EntryStatic.colorSet.block.darken.ANALYSIS,
          arrowColor: EntryStatic.colorSet.arrow["default"].DEFAULT
        }, {
          type: 'Block',
          accept: 'string'
        }],
        events: {},
        def: {
          params: [null, {
            type: 'text',
            params: ['A2']
          }],
          type: 'get_value_from_cell'
        },
        paramsKeyMap: {
          MATRIX: 0,
          CELL: 1
        },
        "class": 'analysis',
        isNotFor: ['analysis'],
        func: function func(sprite, script) {
          var tableId = script.getField('MATRIX', script);
          var cell = script.getValue('CELL', script) || '';
          var _Entry$Utils$cellToRo2 = Entry.Utils.cellToRowCol(cell.toUpperCase()),
            col = _Entry$Utils$cellToRo2.col,
            row = _Entry$Utils$cellToRo2.row;
          var table = _DataTable["default"].getSource(tableId, sprite);
          if (table.isExist([row, col])) {
            return table.getValue([row, col]);
          }
          return null;
        },
        syntax: {
          js: [],
          py: []
        }
      },
      get_value_v_lookup: {
        color: EntryStatic.colorSet.block["default"].ANALYSIS,
        outerLine: EntryStatic.colorSet.block.darken.ANALYSIS,
        skeleton: 'basic_string_field',
        statements: [],
        params: [{
          type: 'DropdownDynamic',
          value: null,
          menuName: 'tables',
          dropdownSync: 'dataTables',
          fontSize: 10,
          bgColor: EntryStatic.colorSet.block.darken.ANALYSIS,
          arrowColor: EntryStatic.colorSet.arrow["default"].DEFAULT
        }, {
          type: 'Block',
          accept: 'string',
          defaultType: 'number'
        }, {
          type: 'Block',
          accept: 'string'
        }, {
          type: 'Block',
          accept: 'string',
          defaultType: 'number'
        }],
        events: {},
        def: {
          params: [null, {
            type: 'get_table_fields'
          }, {
            type: 'text',
            params: ['10']
          }, {
            type: 'get_table_fields'
          }],
          type: 'get_value_v_lookup'
        },
        paramsKeyMap: {
          MATRIX: 0,
          FIELD: 1,
          VALUE: 2,
          RETURN: 3
        },
        "class": 'analysis',
        isNotFor: ['analysis'],
        func: function func(sprite, script) {
          var tableId = script.getField('MATRIX', script);
          var col = _DataTable["default"].getColumnIndex(script.getValue('FIELD', script));
          var returnCol = _DataTable["default"].getColumnIndex(script.getValue('RETURN', script));
          var value = script.getValue('VALUE', script);
          var table = _DataTable["default"].getSource(tableId, sprite);
          var foundIndex;
          for (var i = 0; i < (table === null || table === void 0 || (_table$table = table.table) === null || _table$table === void 0 ? void 0 : _table$table.length) || 0; i++) {
            var _table$table;
            if (table.getValue([i, col]) == value) {
              foundIndex = i;
              break;
            }
          }
          if (table.isExist([foundIndex, returnCol])) {
            return table.getValue([foundIndex, returnCol]);
          }
          return null;
        },
        syntax: {
          js: [],
          py: []
        }
      }
    };
  }
};